var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6048 2.82833V9.76417C13.6048 10.33 13.144 10.8492 12.5782 10.9192L12.3973 10.9425C11.4407 11.0708 10.0932 11.4675 9.00815 11.9225C8.62898 12.08 8.20898 11.7942 8.20898 11.38V3.26583C8.20898 3.05 8.33148 2.85167 8.52398 2.74667C9.59148 2.16917 11.2073 1.65583 12.304 1.5625H12.339C13.039 1.5625 13.6048 2.12833 13.6048 2.82833Z",
    fill: "#445386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0188 2.74667C5.9513 2.16917 4.33546 1.65583 3.2388 1.5625H3.19796C2.49796 1.5625 1.93213 2.12833 1.93213 2.82833V9.76417C1.93213 10.33 2.39296 10.8492 2.9588 10.9192L3.13963 10.9425C4.0963 11.0708 5.4438 11.4675 6.5288 11.9225C6.90796 12.08 7.32796 11.7942 7.32796 11.38V3.26583C7.32796 3.04417 7.2113 2.85167 7.0188 2.74667ZM3.68796 4.51417H5.00046C5.23963 4.51417 5.43796 4.7125 5.43796 4.95167C5.43796 5.19667 5.23963 5.38917 5.00046 5.38917H3.68796C3.4488 5.38917 3.25046 5.19667 3.25046 4.95167C3.25046 4.7125 3.4488 4.51417 3.68796 4.51417ZM5.43796 7.13917H3.68796C3.4488 7.13917 3.25046 6.94667 3.25046 6.70167C3.25046 6.4625 3.4488 6.26417 3.68796 6.26417H5.43796C5.67713 6.26417 5.87546 6.4625 5.87546 6.70167C5.87546 6.94667 5.67713 7.13917 5.43796 7.13917Z",
    fill: "#445386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.fe1b5b80fbdf217ea5e72b365cca36e4.svg";
export { ForwardRef as ReactComponent };